<template>
  <BaseButton
    :class="[
      'text-xs font-semibold px-3 py-2 rounded-t group',
      {
        'text-deep-cerulean': hasDescription,
        'text-abbey': !hasDescription,
        'border-b border-alto': open && !hasDescription,
        'border-b border-deep-cerulean-less-transparent': open && hasDescription
      }
    ]"
    @click="onToggle"
  >
    <div class="flex flex-col">
      <div class="flex justify-between items-center">
        <span>{{ name }}</span>
        <div class="flex flex-1 justify-end items-center">
          <BaseButton
            class="flex"
            @click="onClear($event)"
            v-if="hasDescription"
          >
            <BaseIcon
              class="text-deep-cerulean-less-transparent hover:text-deep-cerulean"
              name="times-circle"
              height="14"
              width="14"
            />
          </BaseButton>
          <BaseIcon
            :class="[
              'ml-4',
              {
                'text-silver-sand group-hover:text-abbey': !hasDescription,
                'text-deep-cerulean-less-transparent group-hover:text-deep-cerulean': hasDescription
              }
            ]"
            :name="open ? 'chevron-up' : 'chevron-down'"
            height="10"
            width="10"
          />
        </div>
      </div>
      <div
        class="flex applied-filters-container font-normal"
        v-if="hasDescription"
      >
        <span>{{ description }}</span>
      </div>
    </div>
  </BaseButton>
</template>

<script>
export default {
  name: 'FilterCategoryButton',
  data() {
    return {
      dateRange: false // temporary
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    open: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    hasDescription() {
      return Boolean(this.description)
    },
    hasDateRange() {
      return this.dateRange
    }
  },
  methods: {
    onClear(event) {
      event.stopPropagation()

      this.$emit('clear')
    },
    onToggle() {
      this.$emit('toggle')
    }
  }
}
</script>

<style scoped>
.applied-filters-container {
  font-size: 10px;
}
</style>
